import { api_routes_v2 } from './api-paths-v2';

export const API_ROUTE_CONFIG = api_routes_v2.v2;
